/* Full-screen product image lightbox.

   Replaces Debut's jQuery $.zoom hover-magnifier (theme.js, _enableZoom),
   which only ever worked with a mouse and is switched off in the section
   settings anyway. Vanilla JS, no dependency, loaded only on the product
   template.

   Gestures: pinch to zoom, drag to pan while zoomed, double-tap to toggle
   zoom, swipe left/right between images, swipe down to dismiss. Mouse:
   wheel to zoom, drag to pan, arrow keys and Esc.

   The overlay is appended to document.body deliberately. #PageContainer
   wraps the whole page and carries overflow:hidden plus a transform at all
   times for the off-canvas drawer/cart, and a transformed ancestor becomes
   the containing block for position:fixed — inside it the overlay would be
   clipped to the page box instead of covering the viewport. */

(function () {
  'use strict';

  var MEDIA_SELECTOR = '.product-redesign .product-single__media';
  /* Set on the image media only. .product-single__media is also the box for
     video, external_video and model media, and those must keep their own
     click behaviour — there is no still to open full screen. */
  var TRIGGER_CLASS = 'bk-lightbox-trigger';
  var MAX_SCALE = 5;
  var DOUBLE_TAP_SCALE = 2.5;
  /* Mapping finger spread straight onto scale (ratio ** 1) makes the zoom
     race ahead of the gesture — a short pinch crosses most of the range at
     once. Damping the exponent keeps the same reachable range but spreads it
     over a much longer travel, so the zoom follows the fingers rather than
     jumping. Lower is gentler. */
  var PINCH_DAMPING = 0.55;
  var SWIPE_DISTANCE = 60;
  var DISMISS_DISTANCE = 110;

  var strings = readStrings();
  var overlay = null;
  var els = {};
  var items = [];
  var index = 0;
  var lastFocused = null;
  var scrollY = 0;

  // Transform state of the open image.
  var scale = 1;
  var tx = 0;
  var ty = 0;

  // Gesture state.
  var pointers = new Map();
  var gesture = null;
  var lastTapTime = 0;
  var lastTapX = 0;
  var lastTapY = 0;
  var lastPointerType = 'mouse';

  function readStrings() {
    var defaults = {
      open: 'Open full-screen image',
      close: 'Close',
      previous: 'Previous image',
      next: 'Next image'
    };
    var node = document.getElementById('ProductLightboxL10n');
    if (!node) return defaults;
    try {
      var parsed = JSON.parse(node.textContent);
      Object.keys(defaults).forEach(function (key) {
        if (parsed[key]) defaults[key] = parsed[key];
      });
    } catch (e) {
      /* Fall back to English rather than leave the controls unlabelled. */
    }
    return defaults;
  }

  /* Pick a rendition wide enough to stand up to pinch-zoom without pulling
     a 2048px file down a phone connection when the screen cannot show it. */
  function bestWidth() {
    var widths = [720, 1080, 1296, 1512, 1728, 2048];
    var longest = Math.max(window.innerWidth, window.innerHeight);
    var target = longest * Math.min(window.devicePixelRatio || 1, 2) * 1.25;
    for (var i = 0; i < widths.length; i++) {
      if (widths[i] >= target) return widths[i];
    }
    return 2048;
  }

  /* Shopify's lazysizes markup keeps the responsive template in data-src as
     ..._{width}x.jpg — swapping the token is how we get a full-size file
     without another round trip to the Files API. */
  function fullSizeUrl(img) {
    var template = img.getAttribute('data-src');
    if (template && template.indexOf('{width}') !== -1) {
      return template.replace('{width}', String(bestWidth()));
    }
    return img.currentSrc || img.src;
  }

  function collectItems() {
    var wrappers = document.querySelectorAll(
      '.product-redesign [data-product-single-media-wrapper]'
    );
    var found = [];
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      var img = wrapper.querySelector('img.product-featured-media');
      if (!img) return; // video, model and external_video wrappers
      found.push({
        media: wrapper.querySelector('.product-single__media'),
        full: fullSizeUrl(img),
        preview: img.currentSrc || img.src,
        alt: img.getAttribute('alt') || ''
      });
    });
    return found;
  }

  function icon(paths) {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      paths +
      '</svg>'
    );
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'bk-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    // Without a name a screen reader announces only "dialog".
    overlay.setAttribute('aria-label', strings.open);
    overlay.innerHTML =
      '<div class="bk-lightbox__stage">' +
      '<img class="bk-lightbox__img" alt="">' +
      '</div>' +
      '<div class="bk-lightbox__spinner"></div>' +
      '<button type="button" class="bk-lightbox__btn bk-lightbox__close">' +
      icon('<path d="M6 6l12 12M18 6L6 18"/>') +
      '</button>' +
      '<button type="button" class="bk-lightbox__btn bk-lightbox__prev">' +
      icon('<path d="M15 5l-7 7 7 7"/>') +
      '</button>' +
      '<button type="button" class="bk-lightbox__btn bk-lightbox__next">' +
      icon('<path d="M9 5l7 7-7 7"/>') +
      '</button>' +
      '<div class="bk-lightbox__counter"></div>';

    document.body.appendChild(overlay);

    els.stage = overlay.querySelector('.bk-lightbox__stage');
    els.img = overlay.querySelector('.bk-lightbox__img');
    els.close = overlay.querySelector('.bk-lightbox__close');
    els.prev = overlay.querySelector('.bk-lightbox__prev');
    els.next = overlay.querySelector('.bk-lightbox__next');
    els.counter = overlay.querySelector('.bk-lightbox__counter');

    els.close.setAttribute('aria-label', strings.close);
    els.prev.setAttribute('aria-label', strings.previous);
    els.next.setAttribute('aria-label', strings.next);

    els.close.addEventListener('click', close);
    els.prev.addEventListener('click', function () { show(index - 1); });
    els.next.addEventListener('click', function () { show(index + 1); });

    els.stage.addEventListener('pointerdown', onPointerDown);
    els.stage.addEventListener('pointermove', onPointerMove);
    els.stage.addEventListener('pointerup', onPointerUp);
    els.stage.addEventListener('pointercancel', onPointerUp);
    els.stage.addEventListener('wheel', onWheel, { passive: false });
    els.stage.addEventListener('dblclick', onDoubleClick);
    els.img.addEventListener('dragstart', function (e) { e.preventDefault(); });

    document.addEventListener('keydown', onKeyDown);

    // Rotating the phone or resizing the window changes both the stage and
    // the drawn size of the photo; without this the image can be left
    // panned outside its own bounds with no way back.
    window.addEventListener('resize', function () {
      if (!overlay.classList.contains('is-open')) return;
      clampPan();
      applyTransform(false);
    });
  }

  /* ---------- Transform ---------- */

  function applyTransform(animate) {
    els.img.classList.toggle('is-animating', !!animate);
    els.img.style.transform =
      'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
    overlay.classList.toggle('is-zoomed', scale > 1.01);
  }

  /* The <img> box always fills the stage, so its offsetWidth says nothing
     about how much picture is actually on screen — object-fit letterboxes
     it. Recover the drawn size from the natural dimensions, the way the
     browser does, so panning stops at the edge of the photo rather than at
     the edge of the empty box around it. */
  function contentSize() {
    var sw = els.stage.clientWidth;
    var sh = els.stage.clientHeight;
    var nw = els.img.naturalWidth;
    var nh = els.img.naturalHeight;
    if (!nw || !nh) return { w: sw, h: sh };
    var fit = Math.min(sw / nw, sh / nh);
    return { w: nw * fit, h: nh * fit };
  }

  function panLimits() {
    var size = contentSize();
    return {
      x: Math.max(0, (size.w * scale - els.stage.clientWidth) / 2),
      y: Math.max(0, (size.h * scale - els.stage.clientHeight) / 2)
    };
  }

  function clampPan() {
    var limit = panLimits();
    tx = Math.min(limit.x, Math.max(-limit.x, tx));
    ty = Math.min(limit.y, Math.max(-limit.y, ty));
  }

  /* Zoom about a point so whatever is under the fingers (or cursor) stays
     under them: with transform-origin at the centre, the image point at
     screen offset p is (p - t) / scale, and holding it fixed across a
     scale change gives t' = p - next * (p - t) / scale. */
  function zoomTo(next, px, py, animate) {
    next = Math.min(MAX_SCALE, Math.max(1, next));
    tx = px - (next * (px - tx)) / scale;
    ty = py - (next * (py - ty)) / scale;
    scale = next;
    if (scale === 1) {
      tx = 0;
      ty = 0;
    } else {
      clampPan();
    }
    applyTransform(animate);
  }

  function resetTransform() {
    scale = 1;
    tx = 0;
    ty = 0;
    applyTransform(false);
  }

  /* Pointer coordinates relative to the centre of the stage. */
  function toStageCentre(clientX, clientY) {
    var rect = els.stage.getBoundingClientRect();
    return {
      x: clientX - (rect.left + rect.width / 2),
      y: clientY - (rect.top + rect.height / 2)
    };
  }

  /* ---------- Gestures ---------- */

  function onPointerDown(event) {
    lastPointerType = event.pointerType || 'mouse';
    // Without capture, a finger released over the close/next buttons (which
    // sit above the stage) delivers pointerup to the button instead, and the
    // entry below is never removed — the next gesture then starts believing
    // two fingers are already down. Capture is released automatically on
    // pointerup and pointercancel.
    if (els.stage.setPointerCapture) {
      try {
        els.stage.setPointerCapture(event.pointerId);
      } catch (e) {
        /* Safari throws for a pointer that has already gone. */
      }
    }
    pointers.set(event.pointerId, {
      x: event.clientX,
      y: event.clientY,
      startX: event.clientX,
      startY: event.clientY
    });

    if (pointers.size === 2) {
      var pair = Array.from(pointers.values());
      gesture = {
        type: 'pinch',
        startDistance: distance(pair[0], pair[1]),
        startScale: scale,
        startTx: tx,
        startTy: ty,
        anchor: toStageCentre(
          (pair[0].x + pair[1].x) / 2,
          (pair[0].y + pair[1].y) / 2
        )
      };
    } else if (pointers.size === 1) {
      gesture = {
        type: scale > 1.01 ? 'pan' : 'swipe',
        startTx: tx,
        startTy: ty,
        moved: false
      };
    }
  }

  function onPointerMove(event) {
    var pointer = pointers.get(event.pointerId);
    if (!pointer || !gesture) return;
    pointer.x = event.clientX;
    pointer.y = event.clientY;

    if (gesture.type === 'pinch' && pointers.size === 2) {
      var pair = Array.from(pointers.values());
      var ratio = distance(pair[0], pair[1]) / gesture.startDistance;
      var damped = Math.pow(ratio, PINCH_DAMPING);
      var next = Math.min(
        MAX_SCALE,
        Math.max(1, gesture.startScale * damped)
      );
      // Re-derive from the gesture's starting transform rather than the
      // running one, so rounding does not accumulate across the pinch.
      tx = gesture.anchor.x - (next * (gesture.anchor.x - gesture.startTx)) / gesture.startScale;
      ty = gesture.anchor.y - (next * (gesture.anchor.y - gesture.startTy)) / gesture.startScale;
      scale = next;
      clampPan();
      applyTransform(false);
      return;
    }

    var dx = pointer.x - pointer.startX;
    var dy = pointer.y - pointer.startY;
    if (Math.abs(dx) > 4 || Math.abs(dy) > 4) gesture.moved = true;

    if (gesture.type === 'pan') {
      tx = gesture.startTx + dx;
      ty = gesture.startTy + dy;
      clampPan();
      applyTransform(false);
    } else if (gesture.type === 'swipe' && dy > 0 && Math.abs(dy) > Math.abs(dx)) {
      // Drag down to dismiss: follow the finger and fade out with it.
      overlay.classList.add('is-dragging');
      els.img.classList.remove('is-animating');
      els.img.style.transform = 'translate(0px, ' + dy + 'px) scale(1)';
      overlay.style.opacity = String(Math.max(0.15, 1 - dy / 400));
    }
  }

  function onPointerUp(event) {
    var pointer = pointers.get(event.pointerId);
    pointers.delete(event.pointerId);

    if (!gesture || !pointer) {
      if (pointers.size === 0) gesture = null;
      return;
    }

    if (gesture.type === 'pinch') {
      // Second finger lifted: settle, and rebase the remaining one so the
      // image does not jump if the user carries on into a pan.
      if (scale <= 1.02) {
        zoomTo(1, 0, 0, true);
      }
      gesture = pointers.size === 1
        ? { type: scale > 1.01 ? 'pan' : 'swipe', startTx: tx, startTy: ty, moved: true }
        : null;
      pointers.forEach(function (p) {
        p.startX = p.x;
        p.startY = p.y;
      });
      return;
    }

    var dx = pointer.x - pointer.startX;
    var dy = pointer.y - pointer.startY;

    if (gesture.type === 'swipe') {
      overlay.classList.remove('is-dragging');
      overlay.style.opacity = '';

      if (dy > DISMISS_DISTANCE && Math.abs(dy) > Math.abs(dx)) {
        close();
        return;
      }
      if (Math.abs(dx) > SWIPE_DISTANCE && Math.abs(dx) > Math.abs(dy)) {
        show(index + (dx < 0 ? 1 : -1));
        return;
      }
      applyTransform(true);

      if (!gesture.moved) {
        // Mice get their double-click from the native dblclick event; doing
        // it here as well would zoom in on pointerup and straight back out
        // when dblclick followed.
        if (event.pointerType !== 'mouse' && isDoubleTap(pointer)) {
          var point = toStageCentre(pointer.x, pointer.y);
          zoomTo(DOUBLE_TAP_SCALE, point.x, point.y, true);
        } else if (event.target === els.stage) {
          // A tap on the backdrop, not the photo, dismisses.
          close();
        }
      }
    } else if (
      gesture.type === 'pan' &&
      !gesture.moved &&
      event.pointerType !== 'mouse' &&
      isDoubleTap(pointer)
    ) {
      zoomTo(1, 0, 0, true);
    }

    if (pointers.size === 0) gesture = null;
  }

  function isDoubleTap(pointer) {
    var now = Date.now();
    var isDouble =
      now - lastTapTime < 320 &&
      Math.abs(pointer.x - lastTapX) < 40 &&
      Math.abs(pointer.y - lastTapY) < 40;
    lastTapTime = isDouble ? 0 : now;
    lastTapX = pointer.x;
    lastTapY = pointer.y;
    return isDouble;
  }

  function distance(a, b) {
    return Math.hypot(a.x - b.x, a.y - b.y);
  }

  function onWheel(event) {
    event.preventDefault();
    var point = toStageCentre(event.clientX, event.clientY);
    var factor = event.deltaY < 0 ? 1.08 : 1 / 1.08;
    zoomTo(scale * factor, point.x, point.y, false);
  }

  function onDoubleClick(event) {
    // Some touch browsers emit dblclick as well as the pointer sequence.
    // Letting both run would zoom in on pointerup and straight back out
    // here, so on touch the pointer path owns the gesture.
    if (lastPointerType !== 'mouse') return;
    event.preventDefault();
    if (scale > 1.01) {
      zoomTo(1, 0, 0, true);
    } else {
      var point = toStageCentre(event.clientX, event.clientY);
      zoomTo(DOUBLE_TAP_SCALE, point.x, point.y, true);
    }
  }

  function onKeyDown(event) {
    if (!overlay || !overlay.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      close();
    } else if (event.key === 'ArrowRight') {
      show(index + 1);
    } else if (event.key === 'ArrowLeft') {
      show(index - 1);
    } else if (event.key === '+' || event.key === '=') {
      zoomTo(scale * 1.25, 0, 0, true);
    } else if (event.key === '-') {
      zoomTo(scale / 1.25, 0, 0, true);
    } else if (event.key === 'Tab') {
      // Keep focus inside the dialog: only the visible controls take it.
      var focusable = [els.close, els.prev, els.next].filter(function (el) {
        return el.offsetParent !== null;
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  /* ---------- Open / close ---------- */

  function show(next) {
    if (!items.length) return;
    // Wrap around, so swiping past either end continues the gallery.
    index = (next + items.length) % items.length;
    var item = items[index];

    resetTransform();
    els.img.alt = item.alt;
    els.counter.textContent = index + 1 + ' / ' + items.length;

    // Show the copy already on the page first — it is in cache, so the
    // overlay never opens empty — then swap in the full-size file.
    els.img.src = item.preview;
    overlay.classList.add('is-loading');

    var full = new Image();
    full.onload = function () {
      if (items[index] === item) {
        els.img.src = full.src;
        overlay.classList.remove('is-loading');
      }
    };
    full.onerror = function () {
      overlay.classList.remove('is-loading');
    };
    full.src = item.full;
  }

  function open(startIndex) {
    items = collectItems();
    if (!items.length) return;

    if (!overlay) build();

    lastFocused = document.activeElement;
    overlay.setAttribute('data-count', String(items.length));
    show(startIndex);

    // Lock the page behind the overlay without losing the reading position.
    scrollY = window.scrollY;
    document.body.style.top = -scrollY + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';

    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    els.close.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open', 'is-dragging', 'is-zoomed');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.opacity = '';
    // A pointerup can be lost (a drag off-screen, a cancelled gesture), and
    // a stale entry here would make the next open start mid-gesture.
    pointers.clear();
    gesture = null;
    resetTransform();

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);

    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---------- Trigger ---------- */

  function init() {
    var media = document.querySelectorAll(MEDIA_SELECTOR);
    if (!media.length) return;

    // Delegated, so a gallery re-rendered on variant change keeps working.
    document.addEventListener('click', function (event) {
      var target = event.target.closest
        ? event.target.closest('.' + TRIGGER_CLASS)
        : null;
      if (!target) return;
      event.preventDefault();
      open(indexOfMedia(target));
    });

    Array.prototype.forEach.call(media, function (el) {
      if (!el.querySelector('img.product-featured-media')) return;
      el.classList.add(TRIGGER_CLASS);
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', strings.open);
      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(indexOfMedia(el));
        }
      });
    });
  }

  function indexOfMedia(el) {
    var found = collectItems();
    for (var i = 0; i < found.length; i++) {
      if (found[i].media === el) return i;
    }
    return 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
